import Steps from "./Steps";
import React from "react";

export function PageHeading(props) {
  let steps = "";
  if(props.customer == "true") {
    steps = <Steps customer={props.customer} history={props.history} urlParams={props.urlParams} />;
  }
  return (
    <div className="row">
      <div className="col-lg-8">
        <h2>{props.title}</h2>
        <p>
          {props.preamble}<br />
          <small>För denna försäkring utgår ingen ersättning eller provision till försäkringsföretagets anställda.</small>
        </p>
        <div className="row mt-4">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <h6>{props.obligatory ? "* Obligatorisk" : ""}</h6>
            {steps}
          </div>
        </div>
      </div>
    </div>
  );
}

PageHeading.defaultProps = {
  obligatory: true
};
